import { MasteryStatus, MasteryStatusPacing, MasteryTimeBooked } from "../enums/MasteryStatus";

// Helper function to check if a value is a valid number for calculations
const isValidNumber = (value: any): value is number => typeof value === 'number' && !isNaN(value);

export const getSkillTimeBalance = (
  masteryTime: number | string,
  assignedTime: number,
  masteryStatus: MasteryStatusPacing,
  boundary:number = 2
) => {
  const adjustedGrowthTime = getAdjustedGrowthTime(masteryTime, masteryStatus);
  const skillBookingStatus = getSkillBookingStatus(
    assignedTime,
    adjustedGrowthTime, // Pass pre-calculated value
    boundary // Default boundary +-<boundary> from assignedTime
  );

  return {
    timeToGrowth: adjustedGrowthTime,
    skillBookingStatus: skillBookingStatus,
    timeToMaster: masteryTime, // return this for bookkeeping
    timeAssigned: assignedTime, // return this for bookkeeping
    masteryGroup: masteryStatus, // return this for bookkeeping
  };
};

export const getAdjustedGrowthTime = (
  masteryTime: number | string,
  masteryStatus: MasteryStatusPacing
): number | string => {
  // Return "--" if status is NO_DATA or masteryTime is not a valid number
  if (!isValidNumber(masteryTime)) return "--";
  const adjuster =
    masteryStatus === MasteryStatusPacing.NOT_DEVELOPED
      ? 1.3
        : masteryStatus === MasteryStatusPacing.LIKELY_MASTERED
          ? 0
            : 1;
  return Math.round(masteryTime * adjuster);
};

export const getSkillBookingStatus = (
  assignedTime: number,
  adjustedGrowthTime: number | string,
  boundary = 2
): MasteryTimeBooked => {
  if (!isValidNumber(assignedTime) || !isValidNumber(adjustedGrowthTime)) {
    return MasteryTimeBooked.NO_DATA;
  }
  const difference = assignedTime - (adjustedGrowthTime as number);

  return Math.abs(difference) <= boundary
    ? MasteryTimeBooked.ON_TRACK
      : Math.abs(difference) === difference
        ? MasteryTimeBooked.OVER_BOOKED
          : MasteryTimeBooked.UNDER_BOOKED;
};